import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks";

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { user, isAuthenticated, loading, isInitialized } = useAuth();

  //  Wait for initialization before checking auth
  if (!isInitialized || loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <div className="h-12 w-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
          <p className="text-gray-600 text-sm font-medium">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(user?.role)) {
    const adminRoles = ["super_admin", "admin"];
    if (adminRoles.includes(user?.role)) {
      return <Navigate to="/app" replace />;
    } else {
      return <Navigate to="/shop" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
